<router-outlet *ngIf="auth.user; else accessForbidden"></router-outlet>
<ng-template #accessForbidden>
  <h3 class="access-forbidden-message">Нет доступа - обратитесь к администратору</h3>
</ng-template>
